export const MESSENGERS = {
    VIBER: 'viber',
    TELEGRAM: 'telegram',
    WHATSAPP: 'whatsapp'
}
